module.exports = __webpack_public_path__ + "static/media/logo_shinhanbank.72826f7a.svg";